import { Box, Text, Flex, Image, For, Heading, Link, Avatar } from "@chakra-ui/react";
import ShadowBox from "@/components/partials/ShadowBox";
import revalidate from '@/lib/revalidate';

export default async function HomeColumnists({ data = [] }) {
  let columnists = [];

  if(data && data.length > 0) {
    columnists = data;
  } else {
      const res = await fetch(`${process.env.NEXT_PUBLIC_API_URL}/portal/componentes/home-colunistas`, {
        next: revalidate('REVALIDATE_HOME_COLUMNISTS')
      });

      const result = await res.json();
      const { data: posts } = result;
      columnists = posts;
  }

  return (
    <ShadowBox text="Colunistas D'Ponta" >
      <Flex justifyContent={{base: 'center', xl: 'space-between'}} p="4" px={{base: '0', xl: '10'}} flexWrap="wrap">
        <For each={columnists}>
          {(item, key) => (
            <Box key={key} flex="25%">
            <Box as={Link} href={`/categoria/${item.columnistCategories.taxSlug}`} minWidth="120px" flex="1" display="block" textAlign="center" className="group" m="4">
              <Image
                  src={item.columnistImages.find(i => i.mediaTyped === 'thumb').mediaCdnUrl}
                  alt={item.columnistName}
                  w="120px"
                  h="120px"
                  rounded="100%"
                  border="5px solid"
                  borderColor={item.columnistColor}  // cor inicial da borda
                  margin="auto"
                  transition="0.3s"
                  _groupHover={{ borderColor: 'blue.500' }}
                />

              <Box>
                <Text fontSize="1.2em" mt="2">
                  { item.columnistCategories.taxName }
                </Text>
              </Box>

              <Box>
                <Text fontSize="0.9em">
                  { item.columnistName }
                </Text>
              </Box>
            </Box>
            </Box>
          )}
        </For>
      </Flex>
    </ShadowBox>
  )
}
